<template>
<b-card>
  <b-row>
    <b-col cols="12" lg="1" class="d-flex align-items-center mb-1">
       <b-dropdown
          variant="flat-secondary"
          class="avenir-medium mr-1 show-dropdown-views"
        >
          <template #button-content>
            <b-icon :icon="view_list ? 'list-ol' : 'grid-fill'" font-scale="1.5" variant="dark" />
          </template>

          <b-dropdown-item @click="view_list = true">
            <b-icon icon="list-ol" font-scale="1" variant="dark" class="mr-05"/>
            {{$t('campaigns.viewList')}}
          </b-dropdown-item>
          <b-dropdown-item @click="view_list = false">
            <b-icon icon="grid-fill" font-scale="1" variant="dark" class="mr-05"/>
            {{$t('campaigns.viewCard')}}
          </b-dropdown-item>
        </b-dropdown>
    <b-button-group class="body-button-center hide-dropdown-views">
        <b-button 
          :class="view_list ? 'button-outline-header-grid-no-active' : 'button-outline-header-grid-active'" 
          :variant="view_list ? 'button-outline-header-grid-no-active' : 'button-outline-header-grid-active'" 
          @click="view_list = false"
        >
          <b-icon icon="grid-fill" font-scale="1.5" variant="dark"></b-icon>
        </b-button>
        <b-button 
          :class="view_list ? 'button-outline-header-grid-active ml-05' : 'button-outline-header-grid-no-active ml-05'" 
          :variant="view_list ? 'button-outline-header-grid-active' : 'button-outline-header-grid-no-active'" 
          @click="view_list = true"
        >
          <b-icon icon="list-ol" font-scale="1.5" variant="dark"></b-icon>
        </b-button>
      </b-button-group>
    </b-col>

    <b-col cols="12" lg="11" class="mb-1">
      <filters-dropdown
        :networks_avaibles="networks_avaibles"
        :actions_options="actions_options"
        :view_actions="true"
        :view_btn_add_content="viewBtnAddContent"
        :btn_action="openSideAddContent"
        @filters-changed="onFiltersChanged"
        @action-selected="onActionSelected"
      />      
    </b-col>
    <b-col>
        <div class="my-1 d-flex" v-if="(!view_list && checkedNames.length > 0) || (view_list && exportable.length > 0)">
          <span>{{$t('creator.selected_contents_check')}}: {{ !view_list ? checkedNames.length : exportable.length }}</span>
        </div>
      </b-col>  
    <div class="w-100" v-if="!view_list && total_results >= 1" :key="updated_cards">
      <contents-view
      :key="updated_cards"
      :checked_uuids="checkedNames"
      :filter_category="filter_category"
      :filter_networks="filter_networks"
      :per_page= "20"
      :query_search= "query"
      @toggle-check="handleToggle"
      @action-remove="removeContent"
      @action-add-form="addFormCard"
      @action-insights="openInsights"
      @action-side-search="openSummaryProfile"/>
    </div>
    <b-card id="container-table-contents" class="col-12"  v-if="view_list && total_results >= 1">
      <vue-good-table
        :columns="columns"
        :rows="info"
        :sort-options="{
          enabled: false,
          multipleColumns: false,
        }"
        :select-options="{
          enabled: true,
          selectOnCheckboxOnly: true,
          selectionInfoClass: 'custom-class',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: true,
          selectAllByGroup: true,
        }"
        @on-cell-click="onCellClick"
        @on-selected-rows-change="selectionChanged"
        class="vgt-table-contents"
      >
        <template slot="table-column" slot-scope="props">
          <div v-if="props.column.field === 'influencer'" class="cursor-pointer">
            {{ $t(props.column.label) }}
            <b-icon icon="chevron-bar-expand" class="float-right"/>
          </div>
          <div v-if="props.column.field === 'category'" class="d-block text-center cursor-pointer">
            {{ $t(props.column.label) }}
            <b-icon icon="chevron-bar-expand" class="float-right"/>
          </div>
          <div v-if="props.column.field === 'network'" class="d-block text-center cursor-pointer">
          {{ $t(props.column.label) }}
            <b-icon icon="chevron-bar-expand" class="float-right"/>
          </div>
          <div v-if="props.column.field === 'followers'" class="d-block text-center cursor-pointer">
            {{ $t(props.column.label) }}
            <b-icon icon="chevron-bar-expand" class="float-right"/>
          </div>
          <div v-if="props.column.field === 'status'" class="d-block text-center cursor-pointer">
            {{ $t(props.column.label) }}
            <b-icon icon="chevron-bar-expand" class="float-right"/>
          </div>
          <div v-if="props.column.field === 'content_type'" class="d-block text-center cursor-pointer">
            {{ $t(props.column.label) }}
            <b-icon icon="chevron-bar-expand" class="float-right"/>
          </div>
            <div v-if="props.column.field === 'created_at'" class="d-block text-center cursor-pointer">
            {{ $t(props.column.label) }}
            <b-icon icon="chevron-bar-expand" class="float-right"/>
          </div>
            <div v-if="props.column.field === 'number_of_views'" class="d-block text-center cursor-pointer">
            {{ $t(props.column.label) }}
            <b-icon icon="chevron-bar-expand" class="float-right"/>
          </div>
          <div v-if="props.column.field === 'engagement'" class="d-block text-center cursor-pointer">
            {{ $t(props.column.label) }}
            <b-icon icon="chevron-bar-expand" class="float-right"/>
          </div>
          <span v-if="props.column.field === 'updated_at'" class="d-block text-center cursor-pointer">
            {{ $t(props.column.label) }}
            <b-icon icon="chevron-bar-expand" class="float-right"/>
          </span>
          <span v-if="props.column.field === 'actions'" class="d-block text-center">
            {{ $t(props.column.label) }}
          </span>
        </template>
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'influencer'" class="text-nowrap">
            <b-media vertical-align="center" class="d-flex align-items-center">
              <template #aside>
                <div class="container-avatar-table">
                  <b-avatar
                    size="md"
                    :src="getImageInfluencer(props.row)"
                    :text="props.row.username[0]"
                    variant="light-primary"
                  />
                </div>
              </template>

              <b-link @click.stop="openSummaryProfile(props.row.influencer)">
                {{ getUsername(props.row) }}
                <image-verified v-if="props.row.is_verified" class="iconCheck"/>
              </b-link>
            </b-media>
          </span>
          <span v-else-if="props.column.field === 'category'" class="text-nowrap d-block text-center p-2">
            <span class="text-nowrap">{{$t(getTypeInfluencerTraduction(props.row.category))}}</span>
          </span>
          <span v-else-if="props.column.field === 'network'" class="text-nowrap d-block text-center">
            <span class="text-nowrap">
              <b-avatar variant="light" size="20">
                <b-img  :src="getIconWhite(props.row.network)" :class="getIconColor(props.row.network, false)" fluid/>
              </b-avatar>
              {{ capitalize(props.row.network)}}
            </span>
          </span>
          <span v-else-if="props.column.field === 'followers'" class="text-nowrap d-block text-center">
            <span class="text-nowrap">{{props.row.followers}}</span>
          </span>
          <span v-else-if="props.column.field === 'status'" class="text-nowrap d-block text-center">
            <span class="text-nowrap">{{$t(`campaigns.statuses.${props.row.status}`)}}</span>
          </span>
          <span v-else-if="props.column.field === 'content_type'" class="text-nowrap d-block text-center">
            <span class="text-nowrap">
              <b-icon class="content-type" :icon="`${getContent(props.row.content_type)}`"/>
              {{getTypeContent(props.row)}}
            </span>
          </span>
          <span v-else-if="props.column.field === 'created_at'" class="text-nowrap d-block text-center">
            <span class="text-nowrap">{{getDatePublish(props.row)}}</span>
          </span>
          <span v-else-if="props.column.field === 'number_of_views'" class="text-nowrap d-block text-center">
            <p v-show="props.row.number_of_views == null" class="text-center mb-0"> - </p>
            <p v-show="props.row.number_of_views != null" class="text-center mb-0">{{separatebycomma(props.row.number_of_views)}}</p>          </span>
          <span v-else-if="props.column.field === 'engagement'" class="text-nowrap d-block text-center">
            <span v-if="props.row.engagement == null || props.row.engagement === 0">-</span>
            <span v-else class="text-nowrap">{{calculateER(props.row)}} %</span>
          </span>
          <span v-else-if="props.column.field === 'updated_at'" class="text-nowrap d-block text-center">
            <span class="text-nowrap">{{getDatev2(new Date(props.row.updated_at))}}</span>
          </span>
          <span v-else-if="props.column.field === 'actions'" class="d-flex justify-content-center align-items-center action-icons-cell">
            <b-link
              v-if="props.row.status !== 'content_pending'"
              :id="`action-watch-${props.row.uuid}`"
              :href="getUrl(props.row)"
              target="_blank"
              class="text-body mr-1"
            >
              <feather-icon icon="EyeIcon" size="18"/>
            </b-link>
            <b-popover v-if="props.row.status !== 'content_pending'" :target="`action-watch-${props.row.uuid}`" triggers="hover" placement="top">
              {{$t('campaigns.watch_content')}}
            </b-popover>

            <span
              :id="`action-insights-${props.row.uuid}`"
              :class="['mr-1', isInsightsEnabled(props.row) ? 'text-body cursor-pointer' : 'text-muted action-icon-disabled']"
              @click="openInsights(props.row)"
            >
              <feather-icon icon="BarChart2Icon" size="18"/>
            </span>
            <b-popover :target="`action-insights-${props.row.uuid}`" triggers="hover" placement="top">
              {{$t('campaigns.content_insights')}}
            </b-popover>

            <template v-if="props.row.status === 'content_published' && props.row.content_type === 'story'">
              <span
                :id="`action-download-${props.row.uuid}`"
                class="text-body cursor-pointer mr-1"
                @click="downloadWithVueResource(props.row.image_content)"
              >
                <feather-icon icon="DownloadIcon" size="18"/>
              </span>
              <b-popover :target="`action-download-${props.row.uuid}`" triggers="hover" placement="top">
                {{$t('campaigns.download_content')}}
              </b-popover>
            </template>

            <template v-if="props.row.can_delete">
              <span
                :id="`action-delete-${props.row.uuid}`"
                class="text-danger cursor-pointer"
                @click="removeContent(props.row.uuid)"
              >
                <feather-icon icon="Trash2Icon" size="18"/>
              </span>
              <b-popover :target="`action-delete-${props.row.uuid}`" triggers="hover" placement="top">
                {{$t('campaigns.delete_content')}}
              </b-popover>
            </template>
          </span>
        </template>


      </vue-good-table>
    </b-card>
    <div class="col-12 row m-0 p-0" v-if="!view_list && loading_creators && total_results >= 1">
      <b-col class="col-12 col-sm-6 col-lg-4 col-xl-3" v-for="i in 8" :key="i">
        <b-card class="card-skeleton padding-card">
          <b-skeleton class="skeleton profile-avatar mb-2"></b-skeleton>
          <b-skeleton class="skeleton h1 col-10"></b-skeleton>
          <b-skeleton class="skeleton col-8 mb-5"></b-skeleton>

          <b-skeleton class="skeleton col-4"></b-skeleton>
          <b-skeleton class="skeleton col-4 mb-7"></b-skeleton>

        </b-card>
      </b-col>
    </div>
    <b-card class="col-12" v-if="view_list && loading_creators && total_results >= 1">
      <b-skeleton-table :rows="8" :columns="11" :table-props="{ small: true }" />
    </b-card>
    <b-col class="col-12" v-if="total_results === 0 && !loading_creators && view_list">
      <no-Results
        :title= "$t('creator.noResultsSearch')"
        :show_button="true"
        :text_button="$t('campaigns.addContentPublish')"
        :show_icon="true"
        :icon="'plus'"
        :class_btn="'blue-button'"
        :btn_action="openSideAddContent"
      />
    </b-col>
    <b-col
      class="col-12"
      v-else-if="!view_list && !loading_creators && !hasPublished"
    >
      <no-Results
        :title= "$t('creator.noResultsSearch')"
        :show_button="true"
        :text_button="$t('campaigns.addContentPublish')"
        :show_icon="true"
        :icon="'plus'"
        :class_btn="'blue-button'"
        :btn_action="openSideAddContent"
      />
    </b-col>

    <b-col v-if="view_list && total_results >= 1" class="d-flex align-items-center justify-content-between flex-wrap">
      <b-dropdown
        variant="flat-secondary"
        class="page-size-dropdown"
        :text="`${$t('campaigns.resultsPerPage')}: ${per_page}`"
      >
        <b-dropdown-item
          v-for="size in page_size_options"
          :key="size"
          @click="updatePerPage(size)"
        >
          {{ size }}
        </b-dropdown-item>
      </b-dropdown>
      <pagination-brandme-v2
        :total_rows="total_results"
        :current_page="current_page"
        :per_page="per_page"
        @update_current_page="updateCurrentPage"
      ></pagination-brandme-v2>
    </b-col>
    <sidebar-content
      v-if="Object.keys(content).length !== 0"
      :show_side="show_side"
      :content_dad="content"
      :campaign_influencer="campaign_influencer"
      :campaign_uuid="campaign_uuid"
      :code_campaign="code_campaign"
      @updateFromSidebar="updateFromSidebar"
      :key="change_sidebar"
    />
    <side-add-content
      :content_dad="content_publish"
      :campaign_uuid="$route.params.uuid"
      :campaign_influencer="campaign_influencer"
      :show_side="show_side_add"
      :key="change_sidebar_add"
      :code_campaign="code_campaign"
      @update_contents="updatedContents"
    />
    <sidebar-search-new
      :open_sidebar="open_sidebar"
      :key="update_sidebar"
      :username="data_sidebar"
      :network="select_network"
      class="open-sidebar-search"
      v-if="open_sidebar"
    >
    </sidebar-search-new>

    <insights-modal
      v-if="show_insights_modal"
      :show_modal="show_insights_modal"
      :insights="insights_content"
      :loading="loading_insights"
      :content_url="insights_content_url"
      :content_preview_url="insights_content_preview_url"
      :key="insights_modal_key"
      @hidden="resetInsights"
    />

  </b-row>
</b-card>
</template>

<script>
import {
  BSkeleton,
  BSkeletonTable,
  BLink,
  BButtonGroup,
  BCard,
  BMedia,
  BAvatar,
  BCol,
  BRow,
  BDropdown,
  BDropdownItem,
  BButton,
  BImg,
  BPopover,
} from 'bootstrap-vue';
import { VueGoodTable } from "vue-good-table";
import service from "@/services/campaign";
import internalCampaignsService from "@/services/internal_campaigns";
import { getIconWhite, getIconColor, getContent } from '@/libs/utils/icons';
import { capitalize, separatebycomma, isVideo, getFormat, decimalFixed } from '@/libs/utils/formats';
import { getDatev2 } from '@/libs/utils/times';
import { getMotivationalPhrase, getImageInfluencer, getTypeInfluencerTraduction, getTypeInfluencerNumber, getTypeInfluencer } from '@/libs/utils/others';
import manage_campaign from '@/services/manage_campaign'
const loadToastificationContent = () => import('@core/components/toastification/ToastificationContent.vue');

export default {
  name: 'publishContent',
  props: {
    slug: {
      type: String,
      required: true
    },
    code_campaign: {
      type: String,
      default: null
    }
  },
  components: {
    BSkeleton,
    BSkeletonTable,
    BLink,
    BButtonGroup,
    BImg,
    BCard,
    BCol,
    BRow,
    BMedia,
    BAvatar,
    VueGoodTable,
    BDropdown,
    BDropdownItem,
    BButton,
    BPopover,
    filtersDropdown: () => import('@/views/components/brandme-ai/dropdowns/filtersDropdown.vue'),
    SidebarSearchNew: () => import('@/views/buscador/SidebarSearchNew.vue'),
    ImageVerified: () => import('@/views/components/image/ImageVerified.vue'),
    sidebarContent: () => import('./sidebarContent.vue'),
    sideAddContent: () => import('./sideAddContent.vue'),
    insightsModal: () => import('./insightsModal.vue'),
    ContentsView: () => import('@/views/campaings/contents/View.vue'),
    noResults: () => import('@/views/pages/proposals/stepper/noResults.vue'),
    paginationBrandmeV2: () => import('@/views/components/pagination/paginationBrandmeV2.vue'),
  },
  data() {
    return {
      getIconColor,
      getIconWhite,
      decimalFixed,
      getFormat,
      isVideo,
      getTypeInfluencerNumber,
      getDatev2,
      separatebycomma,
      getContent,
      capitalize,
      getTypeInfluencerTraduction,
      getImageInfluencer,
      getMotivationalPhrase,
      content_published: false,
      total_contents_update: 0,
      total_contents_published_update: 0,
      local: window.location.origin,
      per_page: 50,
      page_size_options: [10, 25, 50, 100],
      current_page: 1,
      total_results: 0,
      loading_creators: false,
      updated_table: false,
      columns: [
        {
          label: "lists.influencer",
          field: "influencer",
        },
        {
          label: "campaigns.type_influencer",
          field: "category",
          sortable: true,
          sortFn: this.sortFn,
        },
        {
          label: "settings.social.network",
          field: "network",
        },
        {
          label: "campaigns.followers",
          field: "followers",
        },
        {
          label: "campaigns.status",
          field: "status",
        },
        {
          label: "briefcase_pricing.content_type",
          field: "content_type",
        },
        {
          label: "campaigns.date_publish",
          field: "created_at",
        },
        {
          label: "number_of_impressions",
          field: "number_of_views",
          type: 'number',
        },
        {
          label: "campaigns.erTitle",
          field: "engagement",
          type: 'number',
        },
        {
          label: "campaigns.last_update",
          field: "updated_at",
        },
        {
          label: "campaigns.actions",
          field: "actions",
        },
      ],
      service,
      info: [],
      show_modal: false,
      show_side: false,
      show_side_add: false,
      content: {},
      campaign_influencer: '',
      campaign_uuid: '',
      show_add_content: false,
      key_modal_add: false,
      campaign_influencer_to_add: '',
      exportable: [],
      change_sidebar: 0,
      change_sidebar_add: 0,
      interval_loading: null,
      view_list: false,
      checkedNames: [],
      updated_cards: false,
      filter_category: '',
      filter_networks: [],
      query: '',
      networks_avaibles: [
        { value: 'instagram', text: 'Instagram' },
        { value: 'youtube', text: 'YouTube' },
        { value: 'tiktok', text: 'TikTok' },
        { value: 'twitter', text: 'Twitter' },
        { value: 'twitch', text: 'Twitch' },
        { value: 'blog', text: 'Blog' },
        { value: 'snapchat', text: 'Snapchat' },
        { value: 'linkedin', text: 'LinkedIn' },
        { value: 'facebook', text: 'Facebook' },
        { value: 'pinterest', text: 'Pinterest' },
        { value: 'spotify', text: 'Spotify' },
      ],
      open_sidebar: false,
      update_sidebar: false,
      select_network: '',
      content_publish: {
        content_type: '',
        network: "",
        number_of_views: 0,
        number_of_impressions: 0,
        number_of_likes: 0,
        number_of_comments: 0,
        number_of_shares: 0,
        number_of_times_saved: 0,
        published_date: null,
        campaign_influencer: this.campaign_influencer,
        url_info: "",
        image_content: null,
      },
      data_sidebar: '',
      show_insights_modal: false,
      loading_insights: false,
      insights_content: {},
      insights_content_url: '',
      insights_content_preview_url: '',
      insights_modal_key: 0,
    }
  },
  created() {
    this.$vs.loading({
      type: 'sound',
      background: 'rgba(255, 255, 255, 1)',
      text: getMotivationalPhrase(),
    });

    this.interval_loading = setInterval(() => {
      const prev_loading = document.getElementsByClassName('con-vs-loading')[0]

      if (prev_loading) {
        prev_loading.classList.add('fade-out');
        setTimeout(function() {
          prev_loading.remove()
        }, 500);

        this.$vs.loading({
          type: 'sound',
          background: 'rgba(255, 255, 255, 1)',
          text: getMotivationalPhrase(),
        });
      }
    }, 5000);
    this.getContentsManage()
  },
  computed: {
    viewBtnAddContent() {
      if (this.view_list) {
        return this.total_results >= 1
      } else {
        return this.info.some(item => item.status === "content_published")
      }
    },
    hasPublished() {
      return this.info.some(item => item.status === "content_published");
    },
    actions_options() {
      return [
        {
          value: 'select_all',
          text: 'actionSelectAll',
          icon: 'CheckSquareIcon',
          disabled: false,
          view_drop_item: true,
        },
        {
          value: 'unselect_all',
          text: 'actionRemoveSelection',
          icon: 'XSquareIcon',
          disabled: false,
          view_drop_item: true,
        },
        {
          value: 'add_content',
          text: 'addContent',
          icon: 'PlusIcon',
          disabled: false,
          view_drop_item: true,
        },
        {
          value: 'deleteBtn',
          text: 'deleteBtn',
          icon: 'UserMinusIcon',
          disabled: (this.view_list && this.exportable.length === 0) || (!this.view_list && this.checkedNames.length === 0),
          view_drop_item: true,
        },
        {
          value: 'export',
          text: 'export',
          icon: 'ShareIcon',
          disabled: (this.view_list && this.exportable.length === 0) || (!this.view_list && this.checkedNames.length === 0),
          view_drop_item: true,
        },
      ];
    }
  },
  methods: {
    updatedContents() {
      this.getContentsManage();
      this.show_side_add = false;
      this.change_sidebar_add += 1;
    },
    openSideAddContent() {
      this.show_side_add = true;
      this.change_sidebar_add += 1;
    },
    updateCurrentPage(page) {
      this.current_page = page;
    },
    updatePerPage(size) {
      if (this.per_page === size) return;

      this.per_page = size;
      if (this.current_page === 1) {
        this.getContentsManage();
      } else {
        this.current_page = 1;
      }
    },
    onFiltersChanged({ query, type, networks }) {
      this.query = query;
      this.filter_category = type === 'all' ? '' : type;
      this.filter_networks = networks || [];
      this.getContentsManage();
    },
    onActionSelected(action) {
      const action_on = {
        select_all: this.selectAll,
        unselect_all: this.unselectAll,
        deleteBtn: this.bulkRemove,
        export: this.exportSelected,
        add_content: this.openSideAddContent,
      };

      if (action_on[action]) action_on[action]();
    },
    openSummaryProfile(item) {
      this.data_sidebar = item.username;
      this.select_network = item.network;
      this.open_sidebar = true;
      this.update_sidebar = !this.update_sidebar;
    },
    calculateER(content) {

      const comments = content.number_of_comments || 0
      const likes = content.number_of_likes || 0
      const shares = content.number_of_shares || 0
      const views = content.number_of_impressions || 0

      if (views === 0) return 0

      const engagement = comments + likes + shares
      const er = (engagement / views) * 100

      return decimalFixed(er)
    },
    getContentsManage() {
      this.loading_creators = true;

      const filters = {
        statuses: this.view_list ? ['content_published', 'content_pending'] : ['content_published'],
        category: this.filter_category,
        networks: this.filter_networks,
        query: this.query,
      };
      service.getContentsManage(this.$route.params.uuid, this.current_page, this.per_page, filters).then((response) => {
        this.total_results = response.count;
        this.info = this.formatPublished(response.results);
        this.campaign_uuid = this.$route.params.uuid;
        this.loading_creators = false;
        setTimeout(() => {
          clearInterval(this.interval_loading)
          this.$vs.loading.close();
        }, 500);
      });
      this.updated_cards = !this.updated_cards
    },
    handleToggle(uuid) {
      const index = this.checkedNames.indexOf(uuid)
      if (index === -1) this.checkedNames.push(uuid)
      else this.checkedNames.splice(index, 1)
    },

    selectAll() {
      if (this.view_list && (this.exportable.length === 0 || this.exportable.length < this.info.length)) {
        this.$nextTick(() => {
          const selectAllCheckbox = document.querySelector(
            "#container-table-contents > div > div > div > div.vgt-responsive > table > thead > tr > th.vgt-checkbox-col > input[type=checkbox]"
          );
          if (selectAllCheckbox) {
            selectAllCheckbox.click();
          }
        });
      } else {
        this.checkedNames = []
        this.info.forEach(i => {
          this.checkedNames.push(i.uuid)
        })
      }
    },
    unselectAll() {
      if (this.view_list && this.exportable.length > 0) {
        this.$nextTick(() => {
          const selectAllCheckbox = document.querySelector(
            "#container-table-contents > div > div > div > div.vgt-responsive > table > thead > tr > th.vgt-checkbox-col > input[type=checkbox]"
          );
          if (selectAllCheckbox) {
            selectAllCheckbox.click();
            if (this.exportable.length !== this.info.length) selectAllCheckbox.click();
          }
        });
      } else {
        this.checkedNames = []
      }
    },
    getSelectedInfluencers() {
      return this.info.filter(item => this.checkedNames.includes(item.uuid));
    },
    sortFn(x, y) {
      const first = getTypeInfluencerNumber(x)
      const second = getTypeInfluencerNumber(y)
      return (first < second ? -1 : (first > second ? 1 : 0));
    },
    getUrl(content) {
      if (content.url_info) return content.url_info
      return content.image_content
    },
    isInsightsEnabled(content) {
      console.log(content)
      return !!(
        content.deal &&
        content.deal.has_advanced_insights &&
        content.deal.video_id &&
        content.deal.is_video_linked &&
        content.status === 'content_published'
      )
    },
    openInsights(content) {
      if (!this.isInsightsEnabled(content)) return
      this.$root.$emit('bv::hide::popover')
      this.$root.$emit('bv::hide::tooltip')
      this.show_insights_modal = false
      this.insights_content = {}
      this.insights_content_url = content.url_info
      this.insights_content_preview_url = content.content_preview_url
      this.loading_insights = true
      this.$nextTick(() => {
        this.insights_modal_key += 1
        this.show_insights_modal = true
        internalCampaignsService.getInfluencerContentInsights(content.uuid).then(response => {
          this.insights_content = response || {}
          this.loading_insights = false
        })
      })
    },
    resetInsights() {
      this.show_insights_modal = false
      this.loading_insights = false
      this.insights_content = {}
      this.insights_content_url = ''
      this.insights_content_preview_url = ''
    },
    getTypeContent(content) {
      if (content.network === 'tiktok' && content.content_type === 'reel') return this.$t(`invitation.videoVertical`)
      if (content.network === 'blog' && content.content_type === 'post') return 'Blog Post'
      if (content.network === 'snapchat' && content.content_type === 'reel') return 'Spotlight'
      if (content.network === 'youtube' && content.content_type === 'reel') return 'Short'
      return this.$t(`invitation.${content.content_type}`)
    },
    copyLink(data) {
      const url = `${window.location.host}/external-new/details/${this.slug}/${data.network_influencer}/${data.username}`;
      this.$copyText(url).then(
        () => {
          loadToastificationContent().then((component) => {
            this.$toast({
              component: component.default,
              position: 'top-right',
              props: {
                title: this.$t('campaigns.copied'),
                icon: "CopyIcon",
                text: this.$t('campaigns.clipboard'),
                variant: 'success'
              }
            })
          })
        },
        (e) => {
          console.log(e);
        }
      );
    },
    removeContent(uuid) {
      this.$swal({
        title: this.$t('campaigns.textConfirmContent'),
        text: this.$t('campaigns.textContent'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('campaigns.msjConfirmContent'),
        cancelButtonText: this.$t('campaigns.msjCancel'),
        customClass: {
          confirmButton: 'btn confirm-button',
          cancelButton: 'btn btn-outline-danger ml-1'
        },
        buttonsStyling: false,
        heightAuto: false,
      }).then(result => {
        if (!result.value) return

        manage_campaign.deleteBulkContent(this.$route.params.uuid, [uuid]).then(() => {
          this.info = this.info.filter(item => item.uuid !== uuid)
          this.total_results = this.info.length
          this.$emit('update_header');
          this.checkedNames = this.checkedNames.filter(id => id !== uuid)
          this.exportable = this.exportable.filter(row => row.uuid !== uuid)
          this.info.forEach(info => {
            this.exportable.forEach(exp => {
              if (info.uuid === exp.uuid) {
                info.vgtSelected = true;
              }
            });
          });
          this.updated_cards = !this.updated_cards
        })
      })
    },
    selectionChanged(data) {
      this.exportable = data.selectedRows
    },
    downloadWithVueResource (url_info) {
      this.$http.get(url_info, {
        headers: {
          'Access-Control-Allow-Origin': 'Get',
          'Access-Control-Allow-Methods': 'GET',
          'Access-Control-Allow-Headers':'*'
        }
      }, {
        responseType: 'arraybuffer'
      })
        .then(response => {
          this.forceFileDownload(response,url_info)  
        })
        .catch(() => {
          loadToastificationContent().then((component) => {
            this.$toast({
              component: component.default,
              position: 'top-right',
              props: {
                title: this.$t('campaigns.error_status'),
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: this.$t('campaigns.error_status_download')
              }
            })
          })
        })
    },
    forceFileDownload (response,url_info) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      if (isVideo(url_info)) {
        link.setAttribute('download', 'story.mp4')
      } else {
        link.setAttribute('download', 'story.jpg')
      }
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    bulkRemove() {
      let content_uuids = []

      if (this.view_list) {
        content_uuids = this.exportable.map(item => item.uuid)
      } else {
        content_uuids = [...this.checkedNames]
      }

      if (!content_uuids.length) return

      this.$swal({
        title: this.$t('campaigns.textConfirmContent'),
        text: this.$t('campaigns.textContent'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('campaigns.msjConfirmContent'),
        cancelButtonText: this.$t('campaigns.msjCancel'),
        heightAuto: false,
        customClass: {
          confirmButton: 'btn confirm-button',
          cancelButton: 'btn btn-outline-danger ml-1'
        },
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          manage_campaign.deleteBulkContent(this.$route.params.uuid, content_uuids).then(() => {
            this.info = this.info.filter(item => !content_uuids.includes(item.uuid))
            this.total_results = this.info.length
            this.checkedNames = []
            this.exportable = [];
            this.$emit('update_header');
            this.updated_cards = !this.updated_cards
          })
        }
      })
    },
    getDatePublish(content) {
      if (!content.published_date) return '-'
      const date_instance = new Date(content.published_date)
      date_instance.setDate(date_instance.getDate());
      return getDatev2(new Date(date_instance))
    },
    getStatus(status) {
      return status
    },
    formatPublished(contents) {
      const data = [];
      contents.forEach(content => {
        content['username'] = content.influencer.username;
        content['category'] = content.influencer.calculate_category;
        content['image'] = content.influencer.profile_url;
        content['followers'] = getFormat(content.influencer.followers);
        content['engagement'] = decimalFixed(content.influencer.engagement_rate, 2),
        content['profile_url'] = content.influencer.profile_url;
        content['image_url'] = content.influencer.image_url;
        content['file_for_profile'] = content.influencer.file_for_profile;
        content['network_influencer'] = content.influencer.network.toLowerCase();
        content['name'] = content.influencer.name;
        content['is_verified'] = content.influencer.is_verified
        content['status_parent'] = content.status
        content['parent_uuid'] = content.uuid
        content['parent_network'] = content.influencer.network
        data.push(content)
      })
      return data;
    },
    addFormCard(content) {
      this.show_side = true;
      this.content = this.formatCard(content)
      this.campaign_influencer = content.campaing_influencer.uuid;
      this.change_sidebar += 1;
    },
    formatCard(content) {
      const influencer = content.influencer;
      return {
        ...content,
        username: influencer?.username,
        category: influencer?.calculate_category,
        image: influencer?.profile_url,
        followers: getFormat(influencer?.followers),
        engagement: decimalFixed(influencer?.engagement_rate, 2),
        profile_url: influencer?.profile_url,
        image_url: influencer?.image_url,
        file_for_profile: influencer?.file_for_profile,
        network_influencer: influencer?.network?.toLowerCase(),
        name: influencer?.name,
        is_verified: influencer?.is_verified,
        status_parent: content.status,
        parent_uuid: influencer?.uuid,
        parent_network: influencer?.network,
      };
    },
    onCellClick(data) {
      if (data.column.field !== 'actions') {

        this.$nextTick(() => {
          this.campaign_influencer = data.row.campaing_influencer.uuid;
          this.change_sidebar += 1;
          this.content = data.row;
          this.show_side = true;
        });
      }
    },
 
    getUsername(influencer) {
      if (influencer.network_influencer === "youtube") return influencer.name;
      return influencer.username;
    },
    updateFromSidebar(data) {
      if (data !== undefined) {
        const result = this.info.find(item => item.uuid === data.uuid)
        result.status = data.status;
        result.url_info = data.url_info;
        result.number_of_impressions = data.number_of_impressions;
        result.updated_at = data.updated_at;
        result.published_date = data.published_date
        result.number_of_comments = data.number_of_comments
        result.number_of_likes = data.number_of_likes
        result.number_of_prints = data.number_of_prints
        result.number_of_shares = data.number_of_shares
        result.number_of_times_saved = data.number_of_times_saved;
        result.number_of_views = data.number_of_views;
        if (data.image_content) {
          if (isVideo(data.image_content)) {
            result.content_preview_url = data.content_preview_url
          }
          result.image_content = data.image_content
        }
      } 
      this.show_side = false;
      this.change_sidebar += 1;
      this.updated_cards = !this.updated_cards
      this.$emit('update_header');
    },
    exportSelected() {
      this.$vs.loading({
        type: 'sound',
        background: 'rgba(255, 255, 255, 1)',
        text: getMotivationalPhrase(),
      });

      this.interval_loading = setInterval(() => {
        const prev_loading = document.getElementsByClassName('con-vs-loading')[0]

        if (prev_loading) {
          prev_loading.classList.add('fade-out');
          setTimeout(function() {
            prev_loading.remove()
          }, 500);

          this.$vs.loading({
            type: 'sound',
            background: 'rgba(255, 255, 255, 1)',
            text: getMotivationalPhrase(),
          });
        }
      }, 5000);
      let data_export = []
      if (this.view_list) {
        data_export = this.exportable
      } else {
        data_export = this.getSelectedInfluencers()
      }
      const rows = [
        [
          'Nombre del Influencer',
          'Tipo de influencer',
          'Username',
          'Red social',
          'Seguidores',
          'Número de Visualizaciones',
          'Número de Alcance',
          'Número de Interacciones',
          'Número de Comentarios',
          'Número de me Gusta',
          'Número de veces que se compartio',
          'Número de veces que se guardo',
          'URL del contenido que se publicó',
        ]
      ];
      data_export.forEach(data => {
        rows.push([
          data.name,
          getTypeInfluencer(data.category),
          this.getUsername(data),
          capitalize(data.network),
          data.followers,
          data.number_of_views ? data.number_of_views : '-',
          data.number_of_views > 0 ? data.number_of_views : '-',
          data.number_of_likes + data.number_of_comments + data.number_of_shares + data.number_of_times_saved,
          data.number_of_comments > 0 ? data.number_of_comments : '-',
          data.number_of_likes > 0 ? data.number_of_likes : '-',
          data.number_of_shares > 0 ? data.number_of_shares : '-',
          data.number_of_times_saved > 0 ? data.number_of_times_saved : '-',
          data.url_info ? data.url_info : 'N/D',
        ])
      })

      const csv = rows.map(e => e.join(",")).join("\n")
      const downloadLink = document.createElement("a");
      const blob = new Blob(["\ufeff", csv]);
      const url = URL.createObjectURL(blob);

      downloadLink.href = url;
      downloadLink.download = "Influencers publicados.csv";

      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      const self = this
      setTimeout(() => {
        clearInterval(this.interval_loading)
        self.$vs.loading.close();
      }, 200)
    },
  },
  watch: {
    current_page() {
      this.getContentsManage();
    },
    view_list(newValue) {
      if (newValue) {
        // view table selected
        this.checkedNames = [];
        this.getContentsManage();
      } else {
        // view card selected - ContentsView handles its own fetch on mount
        this.exportable = [];
      }
    },
  },  
}
</script>

<style lang="scss" scoped>
.show-dropdown-views {
  display: none;
  @media (min-width: 992px) and (max-width: 1250px) {
    display: block;
  }
}

.hide-dropdown-views {
  @media (min-width: 992px) and (max-width: 1250px) {
    display: none;
  }
}
.padding-card .card-body {
  padding: 0px;
}
.card-skeleton {
  background-color: #fff;
  .card-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
    border-radius: .4rem;
  }
  .skeleton {
    &.profile-avatar {
      width: 100%;
      height: 300px;
    }
  }
}
@media (max-width: 991px) {
  .w-md-100 {
    width: 100% !important;
  }
}
.body-button-center{
  position: relative;
  background-color: #e9ecef;
  padding: .25rem .25rem;
  border-radius: .375rem;

  @media (max-width: 991.98px) {
    width: 100%;
  }
}
.button-outline-header-grid-active {
  background: white;
  padding: 5px 10px;
  border-radius: 6px !important;
}

.button-outline-header-grid-no-active {
  background: transparent;
  padding: 5px 10px;
  border: none;
}
.vgt-table-contents {
  overflow-x: scroll;
}
.action-icons-cell .cursor-pointer {
  cursor: pointer;
}
.action-icon-disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.per-page-selector {
  width: 90px;
}
.name-link:hover {
  text-decoration: underline;
  cursor: pointer;
}
.name-link {
  color: black;
  z-index: 100;
}
.icon-margin-right {
  margin: 0 0.3em 0 0
}
.container-avatar-table {
  position: relative;
}
.container-avatar-table-icon {
  position: absolute; 
  bottom: -5px; 
  left: 22px;
}
.sidebar-icon {
  font-size: 18px;
  margin-right: 10px;
}
.content-type{
  font-size: 15px;
  margin-right: 10px;
  color: #7367F0;
}
</style>


<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
